import { AnimatePresence, motion, useReducedMotion, type Variants } from "framer-motion";
import * as React from "react";
import type { Location } from "react-router-dom";

const easeOut: [number, number, number, number] = [0.22, 0.61, 0.36, 1];
const easeInOut: [number, number, number, number] = [0.4, 0, 0.2, 1];

const variants: Variants = {
  initial: { opacity: 0, y: 8 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.25, ease: easeOut } },
  exit: { opacity: 0, y: -8, transition: { duration: 0.2, ease: easeInOut } },
};

export interface PageTransitionProps {
  children: React.ReactNode;
  location: Location;
  disabled?: boolean;
}

export function PageTransition({ children, location, disabled = false }: PageTransitionProps) {
  const prefersReducedMotion = useReducedMotion();
  if (disabled || prefersReducedMotion) {
    return <>{children}</>;
  }

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location.pathname}
        variants={variants}
        initial="initial"
        animate="animate"
        exit="exit"
        className="min-h-full"
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
}
